import {
  generatePath as generateRoutePath,
  useParams as useRouterParams,
} from "react-router";

type PathParams<Path> = Path extends `:${infer Param}/${infer Rest}`
  ? Param | PathParams<Rest>
  : Path extends `:${infer Param}`
    ? Param
    : Path extends `${infer _Prefix}:${infer Rest}`
      ? PathParams<`:${Rest}`>
      : never;

type PathArgs<TPath, TParams = { [K in PathParams<TPath>]: string }> = TParams;

export const routes = {
  home: "/",
  memdbRedirect: "/memdb",
  createTournament: "/skapa-turnering",
  lobby: "/:room",
  settings: "/:room/installningar",
  game: "/:room/:gid",
  engine: "/dator",
  tournaments: "/turneringar",
} as const;

type Routes = typeof routes;
type RouteKey = keyof Routes;

export function useParams<TRouteKey extends RouteKey>() {
  return useRouterParams<PathParams<Routes[TRouteKey]>>();
}

export function generatePath<TRouteKey extends RouteKey>(
  route: TRouteKey,
  params: PathArgs<Routes[TRouteKey]>,
) {
  // @ts-ignore
  return generateRoutePath(routes[route], params);
}
